import WhatWeDoCard from './WhatWeDoCard';
import HeadingPart from "../../Helper/HeadingPart"

import home from "../../../constants/home";
import headingPart from "../../../constants/headingPart"

// importing svgs
import icon1 from "../../../assets/svg/icon1.svg"
import icon2 from "../../../assets/svg/icon2.svg"
import icon3 from "../../../assets/svg/icon3.svg"

const {
    WHAT_WE_DO_HEADING1,
    WHAT_WE_DO_TEXT1,
    WHAT_WE_DO_HEADING2,
    WHAT_WE_DO_TEXT2,
    WHAT_WE_DO_HEADING3,
    WHAT_WE_DO_TEXT3
} = home;

const {
    HEADING_WHAT_WE_DO,
    TEXT_WHAT_WE_DO
} = headingPart;

const WhatWeDo = () => {
  return (
    <div>
        <HeadingPart heading={HEADING_WHAT_WE_DO} text={TEXT_WHAT_WE_DO} order_1={1} />
        <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-16">
            <WhatWeDoCard  icon={icon1} heading={WHAT_WE_DO_HEADING1} text={WHAT_WE_DO_TEXT1} />
            <WhatWeDoCard  icon={icon2} heading={WHAT_WE_DO_HEADING2} text={WHAT_WE_DO_TEXT2} />
            <WhatWeDoCard  icon={icon3} heading={WHAT_WE_DO_HEADING3} text={WHAT_WE_DO_TEXT3} />
        </div>
    </div>
  )
}

export default WhatWeDo